import map from 'lodash/map';
import min from 'lodash/min';
import omit from 'lodash/omit';
import zipWith from 'lodash/zipWith';
import prop from 'lodash/property';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFilteredParameterValuesNotEmpty, getFilteredParametersValuesNotEmpty } from 'store/dataset';
import { getBinWidth, getStartingPoint } from 'store/scenes/graphicalStatistics/rightPane/selectors';

import Histogram from 'components/Histogram';

class HistogramComponent extends React.PureComponent {

  renderHistogram = () =>
    <Histogram
      withBinWidth
      values={this.histogramData}
      binWidth={this.props.binWidth}
      minDataSet={this.props.minDataSet}
      startPoint={this.props.startPoint}
      xAxisLabel={this.props.numericalParameter}
      isRelativeFrequency={!this.props.isTypeOfGraphsFrequency}
    />

  renderHistograms = () => {
    return map(this.histogramsData, (levelValues, levelName) => {
      const {
        numericalParameter,
        categoricalParameter
      } = this.props;

      const xAxisLabel = `${numericalParameter} for (${categoricalParameter} = '${levelName}')`;

      return (
        <Histogram
          withBinWidth
          key={levelName}
          values={levelValues}
          xAxisLabel={xAxisLabel}
          binWidth={this.props.binWidth}
          minDataSet={this.props.minDataSet}
          startPoint={this.props.startPoint}
          originalValues={flatten(values(omit(this.histogramsData, levelName)))}
          isRelativeFrequency={!this.props.isTypeOfGraphsFrequency}
        />
      );
    });
  }

  get histogramsData () {
    const {
      firstParsedParameterValues,
      secondParsedParameterValues,
      numericalParameter,
      categoricalParameter
    } = this.props;

    const filteredDataset = zipWith(
      firstParsedParameterValues,
      secondParsedParameterValues,
      (value, category) => ({
        [numericalParameter]: value,
        [categoricalParameter]: category
      })
    );

    const numericalGroupedByCategorical = mapValues(
      groupBy(filteredDataset, categoricalParameter),
      datasetChunk => map(datasetChunk, prop(numericalParameter))
    );

    return numericalGroupedByCategorical;
  }

  get histogramData () {
    return this.props.filteredDataset;
  }

  render () {
    return (
      this.props.categoricalParameter ? this.renderHistograms() : this.renderHistogram()
    );
  }
}

HistogramComponent.propTypes = {
  numericalParameter: PropTypes.string.isRequired,
  categoricalParameter: PropTypes.string,
  firstParsedParameterValues: PropTypes.arrayOf(
    PropTypes.number.isRequired
  ).isRequired,

  secondParsedParameterValues: PropTypes.array,
  filteredDataset: PropTypes.array.isRequired,
  binWidth: PropTypes.number.isRequired,
  startPoint: PropTypes.number.isRequired,
  minDataSet: PropTypes.number.isRequired,
  isTypeOfGraphsFrequency: PropTypes.bool.isRequired
};

const mapStateToProps = (state, props) => {

  let filteredValues = {
    firstParsedParameterValues: null,
    secondParsedParameterValues: null
  };

  if (!props.categoricalParameter) {
    filteredValues.firstParsedParameterValues = getFilteredParameterValuesNotEmpty(state, props.numericalParameter);
  } else {
    filteredValues = getFilteredParametersValuesNotEmpty(
      state,
      props.numericalParameter,
      props.categoricalParameter
    );
  }

  return ({
    ...filteredValues,
    filteredDataset: getFilteredParameterValuesNotEmpty(state, props.numericalParameter),
    binWidth: getBinWidth(state),
    startPoint: getStartingPoint(state),
    minDataSet: min(getFilteredParameterValuesNotEmpty(state, props.numericalParameter))
  }
  );
};

export default connect(mapStateToProps)(HistogramComponent);
